// Use that file to override default handlers,
// useful for checking error handling https://mswjs.io/docs/api/setup-worker/use

/* eslint-disable @typescript-eslint/no-unused-vars */
import { http } from "msw";
import { errorResponse } from "./utils";
/* eslint-enable @typescript-eslint/no-unused-vars */

export const overrides = [
  //http.get(`*/v2/token`, () => errorResponse(500)),
  //http.get(`*/v2/refresh`, () => errorResponse(500)),
  //http.post(`*/v2/terms`, () => errorResponse(403)),
  //http.post(`*/v2/terms/accept`, () => errorResponse(500)),
  //http.get(`*/v2/chat/conversations`, () => errorResponse(500)),
  //http.get(`*/v2/chat/conversations/:chat_id/messages`, () => errorResponse(401)),
  //http.post(`*/v2/enhanced/chat`, () => errorResponse(400)),
  //http.post(`*/v2/feedback`, () => errorResponse(500)),
  //http.post(`*/v2/chat/rephrase`, () => errorResponse(401)),
  //http.post(`*/v2/enhanced/chat/new`, () => errorResponse(400)),
];
